(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ResourcesListFormController', ResourcesListFormController);

    ResourcesListFormController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader'];

    function ResourcesListFormController($scope, $state, translate, translatePartialLoader) {
        var vm = this;

    }
})();

